//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// event-suggested-times-warning imports
import { IRendererProps } from "./EventSuggestedTimesWarning.d";
import { EventSuggestedTimesWarning } from "./EventSuggestedTimesWarning";
import { rendererQuery } from "./EventSuggestedTimesWarningRenderer.gql";

//////////////////
// RENDERER
//////////////////
export class EventSuggestedTimesWarningRenderer extends React.Component<IRendererProps> {
  private cachedOrg: ISchema.IOrg | null = null;

  public render() {
    if (!this.props.uncrawledCalendars || !this.props.uncrawledCalendars.length) {
      return <span />;
    }

    return (
      <QueryRenderer
        environment={this.props.environment}
        query={rendererQuery}
        variables={{ orgRelayId: this.props.orgId }}
        render={(readyState: ReadyState) => {
          const freshOrg = readyState.props && readyState.props.node;
          const loadingForTheFirstTime = !this.cachedOrg && !freshOrg;

          // check for error or show a loader for first load
          if (readyState.error || loadingForTheFirstTime) {
            return <span />;
          }

          // cache an org so it doesn't flash on new loads
          if (freshOrg) {
            this.cachedOrg = freshOrg;
          }

          const org = freshOrg || this.cachedOrg;
          return (
            <EventSuggestedTimesWarning
              org={org}
              uncrawledCalendars={this.props.uncrawledCalendars}
            />
          );
        }}
      />
    );
  }
}
